(function () {
    'use strict';

    /*
     * Copyright (c) 2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .constant('CampaignMessagesConstants', {
            query: {
                errorString: 'We were unable to retrieve the messages.'
            },
            save: {
                errorString: 'We were unable to save the message.'
            },
            remove: {
                errorString: 'We were unable to remove the message.'
            },
            types: {
                image: {
                    key: 'images',
                    title: 'Send Image to Patient',
                    message: 'Click the button and select an image to send to this patient for viewing in their In Hand Health app.',
                    errorText: 'Could not upload message image'
                },
                audio: {
                    key: 'audio',
                    title: 'Send Voice Clip to Patient',
                    message: 'Click the button and select a voice clip (saved audio file on your computer) to send to this patient who will receive and listen to it in his or her In Hand Health app.',
                    errorText: 'Could not upload message audio'
                },
                video: {
                    key: 'video',
                    title: 'Send Video to Patient',
                    message: 'Click the button and select a video to send to this patient for viewing in his or her In Hand Health app.',
                    errorText: 'Could not upload message video'
                },
                pdf: {
                    key: 'pdf',
                    title: 'Send PDF',
                    message: 'Click the button and select a PDF to send for viewing in his or her In Hand Health app.',
                    errorText: 'Could not update message pdf'
                },
                stl: {
                    key: 'stl',
                    title: 'Send STL (3D model)',
                    message: 'Click the button and select an STL file to send for viewing in his or her In Hand Health app.',
                    errorText: 'Could not update message STL'
                }
            },
            templateStrings: {
                newMessage: 'Enter Message Text...',
                sendImage: 'Save Image',
                sendVoiceClip: 'Save Voice Clip',
                sendVideo: 'Save Video',
                sendFile: 'Save File',
                send: 'Save',
                noMessages: '[No messages to display.]'
            }
        });
})();